import requestMethods from '@/helpers/request/requestMethods';
import { sectionApiConfig, sectionListApiConfig } from '@/constants/ApiUrls';

function getSectionMetaData({ id }) {
    return requestMethods
        .get({
            routeConfig: sectionApiConfig(id)
        })
        .then((resp) => resp.data);
}

function getSectionData({ id, next }) {
    return requestMethods
        .get({
            routeConfig: {
                ...sectionListApiConfig(id),
                url: next || sectionListApiConfig(id).url
            }
        })
        .then((resp) => resp.data);
}

export { getSectionMetaData, getSectionData };
